import React from "react";
import RacingSport from "../RacingSport/RacingSport";
import Others from "../Others/Others";
import AllSports from "../AllSports/AllSports";
import './sidebar.css'

const Sidebar = () => {
  return (
    <>
      <div className="w-[98%] h-full">
        <RacingSport />
        <Others />
        <AllSports />
      </div>
    </>
  );
};

export default Sidebar;
